<template>
   <c-select
    class="choose-categories-select"
    multiple
    filterable
    popper-class="choose-categories-select-popper"
    clearable
    :value="categoryIds"
    :options="options"
    @change="handleChangeCategoryIds"
  />
</template>

<script>
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import _ from 'lodash';

  @Component
  export default class ChooseCategory extends Vue {
    @Prop(Array) categories;
    @Prop(Array) initCategoryIds;

    categoryIds = [];

    get options() {
      return _.map(this.categories, (category) => {
        return {
          label: category.name,
          options: _.map(category.children, (item) => ({ label: item.name, value: item.id }))
        }
      })
    }

    handleChangeCategoryIds(val) {
      this.categoryIds = val;
      this.$emit('change', this.categoryIds);
    }

    @Watch('initCategoryIds', { immediate: true })
    onInitCategoryIdsChange(initCategoryIds) {
      this.categoryIds = initCategoryIds;
    }
  }
</script>

<style lang="scss">
  .choose-categories-select {
    width: 250px;
  }
  .choose-categories-select-popper {
    z-index: 99999 !important;
  }
</style>
